var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('u-header',{attrs:{"title":_vm.$t('_.automation'),"has-brand-switcher":true,"cta":_vm.$userCan('create_template')
          ? _vm.$t('_action.add_object', { object: _vm.$t('_.action').toLowerCase() })
          : null},on:{"click":function($event){return _vm.$router.push({
          name: 'adminAutomationAddAction',
          query: _vm.$route.query
        })}}},[_c('tabigation',{attrs:{"slot":"tabs","routes":_vm.routes()},slot:"tabs"})],1),_vm._v(" "),_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }